import layoutHeaderAside from "@/layout/header-aside";

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require("@/libs/util.import." + process.env.NODE_ENV);

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: "/",
    redirect: { name: "index" },
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: "index",
        name: "index",
        component: _import("Dashbord/Dashbord"),
      },

      // 客户
      {
        path: "Customer",
        name: "Customer",
        component: _import("Customer/Customer"),
      },
      {
        path: "CustomerManagement",
        name: "CustomerManagement",
        component: _import("Customer/CustomerManagement"),
      },
      // 客户
      {
        path: "CustomerSalesInfo",
        name: "CustomerSalesInfo",
        component: _import("Customer/Customer"),
      },
      {
        path: "CustomerDet",
        name: "CustomerDet",
        meta: {
          hidden: true,
        },
        component: _import("Customer/CustomerDet"),
      },

      // 订单
      {
        path: "Order",
        name: "Order",
        component: _import("Order/Order"),
      },
      {
        path: "OrderContract",
        name: "OrderContract",
        meta: {
          hidden: true,
        },
        component: _import("Order/OrderContract"),
      },
      {
        path: "OrderDet",
        name: "OrderDet",
        meta: {
          hidden: true,
        },
        component: _import("Order/OrderDet"),
      },

      // 报表
      {
        path: "Report",
        name: "Report",
        component: _import("Report/Report"),
      },
      {
        path: "ReportDet",
        name: "ReportDet",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportDet"),
      },
      {
        path: "Report",
        name: "Report",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportOne"),
      },
      {
        path: "ReportOne",
        name: "ReportOne",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportOne"),
      },
      {
        path: "ReportTwo",
        name: "ReportTwo",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportTwo"),
      },
      {
        path: "ReportThree",
        name: "ReportThree",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportThree"),
      },
      {
        path: "ReportFour",
        name: "ReportFour",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportFour"),
      },
      {
        path: "ReportFive",
        name: "ReportFive",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportFive"),
      },
      {
        path: "ReportSix",
        name: "ReportSix",
        meta: {
          hidden: true,
        },
        component: _import("Report/RerportSix"),
      },
      {
        path: "ReportSeven",
        name: "ReportSeven",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportSeven"),
      },
      {
        path: "ReportEight",
        name: "ReportEight",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportEight"),
      },
      {
        path: "ReportNine",
        name: "ReportNine",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportNine"),
      },
      {
        path: "ReportTen",
        name: "ReportTen",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportTen"),
      },
      {
        path: "ReportEleven",
        name: "ReportEleven",
        meta: {
          hidden: true,
        },
        component: _import("Report/ReportEleven"),
      },
      {
        path: "ReportTwenty",
        name: "ReportTwenty",
        component: _import("Report/ReportTwenty"),
      },
      {
        path: "ReportTwentyDetail",
        name: "ReportTwentyDetail",
        meta: {
          hidden: true,
        },
        component: _import("Report/components/reportTwentyDetail"),
      },

      // 出差
      {
        path: "Travel",
        name: "Travel",
        component: _import("Travel/Travel"),
      },
      {
        path: "addTravel",
        name: "addTravel",
        meta: {
          hidden: true,
        },
        component: _import("Travel/components/addTravel"),
      },

      // 竞品
      {
        path: "competitors",
        name: "competitors",
        component: _import("competitors/competitors"),
      },
      {
        path: "addCompetitors",
        name: "addCompetitors",
        meta: {
          hidden: true,
        },
        component: _import("competitors/addCompetitors"),
      },

      // 商品
      {
        path: "competingGoods",
        name: "competingGoods",
        component: _import("competingGoods/competingGoods"),
      },
      {
        path: "competingGoodsInfo",
        name: "competingGoodsInfo",
        meta: {
          hidden: true,
        },
        component: _import("competingGoods/competingGoodsInfo"),
      },
      {
        path: "addCompetingGoods",
        name: "addCompetingGoods",
        meta: {
          hidden: true,
        },
        component: _import("competingGoods/addCompetingGoods"),
      },
      {
        path: "editCompetingGoods",
        name: "editCompetingGoods",
        meta: {
          hidden: true,
        },
        component: _import("competingGoods/editCompetingGoods"),
      },

      {
        path: "exhibition",
        name: "exhibition",
        component: _import("Commitments/Commitments"),
      },
      {
        path: "Commitments",
        name: "Commitments",
        component: _import("Commitments/Commitments"),
      },
      {
        path: "tableList",
        name: "tableList",
        meta: {
          hidden: true,
        },
        component: _import("Commitments/tableList"),
      },
      {
        path: "tableListbyCustomer",
        name: "tableListbyCustomer",
        meta: {
          hidden: true,
        },
        component: _import("Commitments/tableListbyCustomer"),
      },
      {
        path: "TotalCommitments",
        name: "TotalCommitments",
        meta: {
          hidden: true,
        },
        component: _import("Commitments/TotalCommitments"),
      },
      {
        path: "addCommitments",
        name: "addCommitments",
        meta: {
          hidden: true,
        },
        component: _import("Commitments/addCommitments"),
      },

      // 视频和图片
      {
        path: "lmageVideo",
        name: "lmageVideo",
        component: _import("Video/Video"),
      },
      {
        path: "addVideo",
        name: "addVideo",
        meta: {
          hidden: true,
        },
        component: _import("Video/addVideo"),
      },
      {
        path: "addCover",
        name: "addCover",
        meta: {
          hidden: true,
        },
        component: _import("Video/addCover"),
      },
      // 视频和图片
      {
        path: "Cover",
        name: "Cover",
        component: _import("Video/Cover"),
      },

      // 知识库
      {
        path: "Catalog",
        name: "Catalog",
        component: _import("Documents/Documents"),
      },
      {
        path: "addDocuments",
        name: "addDocuments",
        meta: {
          hidden: true,
        },
        component: _import("Documents/addDocuments"),
      },

      // 业绩
      {
        path: "Performance",
        name: "Performance",
        component: _import("Performance/Performance"),
      },
      {
        path: "Performance2",
        name: "Performance2",
        meta: {
          hidden: true,
        },
        component: _import("Performance/Performance2"),
      },
      {
        path: "Performance3",
        name: "Performance3",
        meta: {
          hidden: true,
        },
        component: _import("Performance/Performance3"),
      },
      {
        path: "addPerformance",
        name: "addPerformance",
        meta: {
          hidden: true,
        },
        component: _import("Performance/addPerformance"),
      },

      {
        path: "admin",
        name: "admin",
        meta: {
          hidden: true,
        },
        component: _import("Admin/arms"),
      },
      {
        path: "arms",
        name: "arms",
        meta: {
          hidden: true,
        },
        component: _import("Admin/arms"),
      },
      {
        path: "backs",
        name: "backs",
        meta: {
          hidden: true,
        },
        component: _import("Admin/backs"),
      },
      {
        path: "categories",
        name: "categories",
        meta: {
          hidden: true,
        },
        component: _import("Admin/categories"),
      },
      {
        path: "features",
        name: "features",
        meta: {
          hidden: true,
        },
        component: _import("Admin/features"),
      },
      {
        path: "mechanisms",
        name: "mechanisms",
        meta: {
          hidden: true,
        },
        component: _import("Admin/mechanisms"),
      },
      {
        path: "seats",
        name: "seats",
        meta: {
          hidden: true,
        },
        component: _import("Admin/seats"),
      },
      {
        path: "sku",
        name: "sku",
        meta: {
          hidden: true,
        },
        component: _import("Admin/sku"),
      },
      {
        path: "styles",
        name: "styles",
        meta: {
          hidden: true,
        },
        component: _import("Admin/styles"),
      },
      {
        path: "arrangements",
        name: "arrangements",
        meta: {
          hidden: true,
        },
        component: _import("Admin/arrangements"),
      },
      {
        path: "covers",
        name: "covers",
        meta: {
          hidden: true,
        },
        component: _import("Admin/covers"),
      },
      {
        path: "coversGrades",
        name: "coversGrades",
        meta: {
          hidden: true,
        },
        component: _import("Admin/coversGrades"),
      },
      {
        path: "coversGroups",
        name: "coversGroups",
        meta: {
          hidden: true,
        },
        component: _import("Admin/coversGroups"),
      },
      {
        path: "models",
        name: "models",
        meta: {
          hidden: true,
        },
        component: _import("Admin/models"),
      },
      {
        path: "price",
        name: "price",
        meta: {
          hidden: true,
        },
        component: _import("Admin/price"),
      },

      // 其他
      {
        path: "DFSEDIInvolce",
        name: "DFSEDIInvolce",
        component: _import("others/DFSEDIInvolce"),
      },

      //重置密码
      {
        path: "resetPassword",
        name: "resetPassword",
        component: _import("system/resetPwd/index"),
      },

      // demo
      {
        path: "demo",
        name: "demo",
        meta: {
          hidden: true,
        },
        component: _import("deme"),
      },

      // 系统 前端日志
      {
        path: "log",
        name: "log",
        meta: {
          title: "前端日志",
          hidden: true,
        },
        component: _import("system/log"),
      },

      // 刷新页面 必须保留
      {
        path: "refresh",
        name: "refresh",
        hidden: true,
        meta: {
          hidden: true,
        },
        component: _import("system/function/refresh"),
      },

      // 页面重定向 必须保留
      {
        path: "redirect/:route*",
        name: "redirect",
        hidden: true,
        meta: {
          hidden: true,
        },
        component: _import("system/function/redirect"),
      },

      // 库存共享-产品信息配置
      {
        path: "InventoryPlatformProductInfoConfig",
        name: "InventoryPlatformProductInfoConfig",
        component: _import("InventoryPlatform/ProductInfoConfig"),
      },
      // 库存共享-客户数据
      {
        path: "InventoryPlatformCustomerData",
        name: "InventoryPlatformCustomerData",
        component: _import("InventoryPlatform/CustomerData"),
      },
      // 库存共享-客户数据
      {
        path: "InventoryPlatformCustomerDataNew",
        name: "InventoryPlatformCustomerDataNew",
        component: _import("InventoryPlatform/CustomerData"),
      },
      // 库存共享-库存共享报表
      {
        path: "InventoryPlatformSharingReport",
        name: "InventoryPlatformSharingReport",
        component: _import("InventoryPlatform/SharingReport"),
      },
      // 新款维护
      {
        path: "NewStyleMaintenance",
        name: "NewStyleMaintenance",
        component: _import("Admin/NewStyleMaintenance/index"),
      },
      // 规格关系
      {
        path: "SpecificationRelationship",
        name: "SpecificationRelationship",
        component: _import("Admin/SpecificationRelationship/index"),
      },
      // 跟进情况表
      {
        path: "FollowUpSituationTable",
        name: "FollowUpSituationTable",
        component: _import("Commitments/FollowUpSituationTable/index"),
      },
      // 确认订单明细
      {
        path: "ConfirmOrderDetails",
        name: "ConfirmOrderDetails",
        component: _import("Commitments/ConfirmOrderDetails/index"),
      },
      // 展会奖金报表
      {
        path: "MarketNewModelBonusReport",
        name: "MarketNewModelBonusReport",
        component: _import("Commitments/MarketNewModelBonusReport/index"),
      },
      // 展会
      {
        path: "ExReservation",
        name: "ExReservation",
        component: _import("Commitments/ExReservation"),
      },
    ],
  },
];

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: "/login",
    name: "login",
    meta: {
      pass: true,
    },
    component: _import("system/login"),
  },
];

/**
 * 错误页面
 */
const errorPage = [
  {
    path: "*",
    name: "404",
    meta: {
      pass: true,
    },
    component: _import("system/error/404"),
  },
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage];
